'use client';

import { usePathname } from 'next/navigation';

let prevPathname: string | null = null;

const NavigationScrollRestore = () => {
  const pathname = usePathname();

  if (typeof window !== 'undefined') {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    const pathnameChanged = prevPathname !== null && prevPathname !== pathname;
    const enteredWithPreservedScroll =
      prevPathname !== pathname && window.scrollY > 0;

    if (pathnameChanged || enteredWithPreservedScroll) {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }

    prevPathname = pathname;
  }

  return null;
};

export { NavigationScrollRestore };
